import { render, staticRenderFns } from "./frozenDetail.vue?vue&type=template&id=5dcce966&scoped=true"
import script from "./frozenDetail.vue?vue&type=script&lang=js"
export * from "./frozenDetail.vue?vue&type=script&lang=js"
import style0 from "./frozenDetail.vue?vue&type=style&index=0&id=5dcce966&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcce966",
  null
  
)

export default component.exports